export default __webpack_public_path__ + "8e8f380bdbadb8c17e33ffdbaa9b26da.svg";